import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>404</h1>
      <p>The page you are looking for was not found.</p>
      <Link to="/" style={{ textDecoration: "none" }}>
        <button style={{ marginTop: "20px", padding: "10px 20px", fontSize: "16px", cursor: "pointer" }}>
          Go to Home
        </button>
      </Link>
    </div>
  );
};

export default NotFound;
